import { template } from "@ember/template-compiler";
import Component from "@glimmer/component";
import { SECOND_FACTOR_METHODS } from "discourse/models/user";
export default class SecondFactorInput extends Component {
    get isTotp() {
        return this.args.secondFactorMethod === SECOND_FACTOR_METHODS.TOTP;
    }
    get isBackupCode() {
        return this.args.secondFactorMethod === SECOND_FACTOR_METHODS.BACKUP_CODE;
    }
    get type() {
        if (this.isTotp) {
            return "tel";
        } else if (this.isBackupCode) {
            return "text";
        }
    }
    get pattern() {
        if (this.isTotp) {
            return "[0-9]{6}";
        } else if (this.isBackupCode) {
            return "[a-z0-9]{16}";
        }
    }
    get maxlength() {
        if (this.isTotp) {
            return "6";
        } else if (this.isBackupCode) {
            return "32";
        }
    }
    static{
        template(`
    <input
      type={{this.type}}
      pattern={{this.pattern}}
      maxlength={{this.maxlength}}
      autocomplete="one-time-code"
      autocapitalize="off"
      autocorrect="off"
      autofocus="autofocus"
      class="second-factor-token-input"
      ...attributes
    />
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
